export default __webpack_public_path__ + "static/media/hht1_ep18_timeline_q03_b.d98f5b73.png";